export default from './DesktopHeader';



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Header/components/DesktopHeader/index.js